import NAME from "./constants";

export const QUERY = NAME + "/QUERY";
export const QUERY_FULFILLED = NAME + "/QUERY_FULFILLED";
export const QUERY_REJECTED = NAME + "/QUERY_REJECTED";
export const CLEAR_QUERY = NAME + "/CLEAR_QUERY";